import React from "react";

import download from "../../assets/img/ico/download.svg";

export default function AttestationsWidget() {


    return (
        <div className={"attestations-widget"}>
            <div>
                <h3>Attestations</h3>
                <button className={"btn empty"}>Nouvelle demande</button>
            </div>
            <div>
                <p>Attestation pôle emploi</p>
                <p>Mars 2025 - Avril 2025</p>
                <button className={"btn fill green"}>accepter</button>
                <img src={download} alt="download" />
            </div>
        </div>
    )
}
